var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"tituloPagina"}},[_c('h2',[(_vm.$props.titulo.textoMenor)?_c('span',[_vm._v(_vm._s(_vm.$props.titulo.textoMenor))]):_vm._e(),_vm._v(_vm._s(_vm.$props.titulo.textoMaior))])])
}
var staticRenderFns = []

export { render, staticRenderFns }